<template>
  <v-container fluid style="max-width: 1400px; margin-left: 0;"
		:style="'height:'+$store.getters['general/availableHeight']+'px;overflow:scroll;'"
		:class="isScrolled ? 'pt-0' : ''"
		@scroll="onScroll">
		<div v-if="loadingBudgetInfo">
			<p class="text-center caption">Cargando Presupuesto</p>
			<v-skeleton-loader
				type="heading"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="paragraph"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="text"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="paragraph"
				class="my-2 mx-6"
			></v-skeleton-loader>
		</div>
		<div v-else>
			<v-card :loading="loadingBudget" :disabled="loadingBudget" class="budget-modal-card mb-2"
				ref="budgetHeaderInfo"
				:style="isScrolled ? {
					position: 'sticky',
					top: '0px',
					left: '0',
					right: '0',
					zIndex: 9
				} : {}">
				<v-card-text class="py-4">
					<div class="d-flex align-start flex-grow-1 caption" v-if="budget">
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Presupuesto</div><span>:</span> <b class="text-end" style="flex: 1;">{{ budget.serial?.serial }} - LP{{ budget.morphable?.project_line_info?.project_line?.number }} - {{ budget.prefix?.prefix }} {{ budget.info?.budget_prefix_index }}</b>
								<div class="action-container">
									<v-menu v-model="prefixMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
										<template v-slot:activator="{ on, attrs }">
											<div class="action-container">
												<v-tooltip bottom>
													<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
														<v-btn
															icon
															color="warning"
															x-small
															:disabled="!canEditInfo"
															v-bind="{ ...attrs, ...tooltipAttrs }"
															v-on="{ ...on, ...tooltipOn }"
														>
															<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
														</v-btn>
													</template>
													<span>Cambiar Prefijo</span>
												</v-tooltip>
											</div>
										</template>
										<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
											<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
												<p class="caption mb-0 font-weight-bold white--text">Cambiar Prefijo Presupuesto</p>
											</v-list-item>
											<v-list-item-group color="#524D4D">
												<v-list-item
													v-for="(prefix, index) in $store.state.budget.companiesBudgetPrefixes"
													:key="index"
													dense
													@click="changeBudgetPrefix(prefix.id)"
												>
													<v-list-item-title dense>
														{{ prefix.prefix }} - {{ prefix.name }}
													</v-list-item-title>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-menu>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Detalle</div><span>:</span>
								<div class="d-flex flex-column flex-grow-1 justify-end">
									<div class="d-flex flex-grow-1 justify-end caption">
										<v-icon x-small class="mr-2">{{getTypeIcon(budget.morphable_type)}}</v-icon> <p class="mb-0 font-weight-bold" style="font-size: 10px;">{{ getTypeName(budget.morphable_type)}}</p>
									</div>
									<div class="d-flex flex-grow-1 justify-end caption">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<p
													class="mb-0 text-truncate"
													style="max-width: 180px;"
													v-bind="attrs"
													v-on="on"
												>
													{{ budget.morphable?.name }}
												</p>
											</template>
											<span>{{ budget.morphable?.name }}</span>
										</v-tooltip>
									</div>
								</div>
								<div class="action-container align-start">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												color="warning"
												x-small
												v-bind="attrs"
												v-on="on"
												@click="gotToAssociation(budget)"
											>
												<v-icon dark small>mdi-eye-outline</v-icon>
											</v-btn>
										</template>
										<span>Ir al detalle</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Dirección</div><span>:</span>
								<div class="d-flex flex-grow-1 justify-end align-center ml-2">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<p
												class="mb-0 text-truncate caption"
												style="max-width: 200px;"
												v-bind="attrs"
												v-on="on"
											>
												{{ budget.morphable?.info?.address?.address }}
											</p>
										</template>
										<span>{{ budget.morphable?.info?.address?.address }}</span>
									</v-tooltip>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Estado</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<v-chip
										:color="budget.last_status?.status | budgetStatusColor"
										label
										outlined
										x-small
									>
										<b>{{ budget.last_status?.status | budgetStatus }}</b>
									</v-chip>
								</div>
								<div class="action-container"></div>
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Responsable</div><span>:</span> <b class="text-end" style="flex: 1;">{{ userResponsible ? userResponsible:'Sin Responsable' }}</b>
								<div class="action-container">
									<v-menu v-model="responsibleMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
										<template v-slot:activator="{ on, attrs }">
											<div class="action-container">
												<v-tooltip bottom>
													<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
														<v-btn
															icon
															color="warning"
															x-small
															:disabled="!$checkPermissions(['assign_responsible_user'])"
															v-bind="{ ...attrs, ...tooltipAttrs }"
															v-on="{ ...on, ...tooltipOn }"
														>
															<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
														</v-btn>
													</template>
													<span>Cambiar Responsable</span>
												</v-tooltip>
											</div>
										</template>
										<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
											<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
												<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
											</v-list-item>
											<v-list-item-group color="#524D4D">
												<v-list-item
													v-for="(responsible, index) in $store.state.users.usersList"
													:key="index"
													dense
													@click="changeResponsible(responsible.id)"
												>
													<v-list-item-title dense>
														<div class="d-flex align-center">
															<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
															<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
															<div>
																<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
																<p class="mb-0 caption">{{ responsible.email }}</p>
															</div>
														</div>
													</v-list-item-title>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-menu>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Cliente</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{budget.morphable?.client?.profile?.name}} {{budget.morphable?.client?.profile?.lastname}} {{budget.morphable?.client?.profile?.second_lastname}}</p>
								</div>
								<div class="action-container">
									<v-menu v-model="userCompanyMenu" offset-y nudge-left="350px" z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;"
										v-if="budget.morphable?.client?.company_profile && budget.morphable?.client?.accreditation?.status">
										<template v-slot:activator="{ on, attrs }">
											<v-tooltip bottom>
												<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
													<v-btn
														icon
														color="#FF1209"
														x-small
														v-bind="{ ...attrs, ...tooltipAttrs }"
														v-on="{ ...on, ...tooltipOn }"
													>
														<v-icon dark small>mdi-domain</v-icon>
													</v-btn>
												</template>
												<span>Cliente Empresa</span>
											</v-tooltip>
										</template>
										<v-card min-width="400px">
											<v-card-text>
												<div class="caption" v-if="budget.morphable?.client?.company_profile">
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre Empresa</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.name}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.rut | formatRut}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.email}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.phone}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.address}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.rep_name}} {{budget.morphable?.client?.company_profile.rep_first_lname}} {{budget.morphable?.client?.company_profile.rep_second_lastname}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.email}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.rep_rut | formatRut}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{budget.morphable?.client?.company_profile.rep_address}}</b></div>
												</div>
											</v-card-text>
										</v-card>
									</v-menu>
									<v-tooltip bottom v-else>
										<template v-slot:activator="{ on, attrs }">
											<v-icon small color="#959595"
												v-bind="attrs"
												v-on="on">mdi-account</v-icon>
										</template>
										<span>Cliente Persona Natural</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Rut</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{budget.morphable?.client?.profile?.rut | formatRut}}</p>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Teléfono</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{budget.morphable?.client?.profile?.phone}}</p>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Email</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{budget.morphable?.client?.email}}</p>
								</div>
								<div class="action-container"></div>
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-column justify-end align-end" style="width: 270px;min-width: 270px;">
							<div class="d-flex mb-2 justify-end align-center flex-grow-1" style="width: 100%;">
								<v-btn
									depressed
									color="#FF120B"
									class="mr-2 flex-grow-1"
									x-small
									dark
									@click="confirmBudget(true, true)"
								>
									<v-icon small>mdi-check</v-icon>
									<p class="mb-0 ml-1 caption">Guardar</p>
								</v-btn>
								<div class="d-flex justify-end">
									<BudgetPdfHistory :budget="budget" />
									<BudgetStatusHistory :budget="budget" />
									<BudgetSettings />
								</div>
							</div>
							<div class="d-flex justify-end align-start w-100" v-if="budget.last_status?.status == budgetStatuses.ACEPTADO">
								<div class="d-flex flex-column align-end justify-end flex-grow-1">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="#959595"
												dark
												class="mb-1"
												small
												outlined
												block
												@click="createContract"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small>mdi-briefcase-outline</v-icon>
												<p class="mb-0 ml-2 caption">Pasar a Contrato</p>
											</v-btn>
										</template>
										<span>Pasar el presupuesto a contrato</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="#959595"
												dark
												small
												outlined
												block
												class="mb-1"
												@click="$store.commit('budget/setBudgetPdfModal', budget)"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small>mdi-file-pdf-box</v-icon>
												<p class="mb-0 ml-2 caption">Ver Presupuesto Aceptado Cliente</p>
											</v-btn>
										</template>
										<span>Ver el PDF del Presupuesto</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex justify-end align-start w-100" v-else-if="budget.last_status?.status == budgetStatuses.RECHAZADO">
								<div class="d-flex flex-column align-end justify-end flex-grow-1">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="#959595"
												dark
												small
												outlined
												block
												class="mb-1"
												@click="$store.commit('budget/setBudgetPdfModal', budget)"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon small>mdi-file-pdf-box</v-icon>
												<p class="mb-0 ml-2 caption">Ver Presupuesto Rechazado Cliente</p>
											</v-btn>
										</template>
										<span>Ver el PDF del Presupuesto</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex align-start justify-end flex-grow-1 w-100">
								<div class="d-flex align-start justify-end flex-grow-1">
									<div class="d-flex flex-column align-end justify-end flex-grow-1" v-if="userResponsible && !disableContentBudget">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="green"
													dark
													class="mb-1"
													small
													block
													@click="startShowBudgetPreview"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-file-pdf-box</v-icon>
													<p class="mb-0 ml-2 caption">{{startPreviewButtonText}}</p>
												</v-btn>
											</template>
											<span>{{startPreviewButtonTextTooltip}}</span>
										</v-tooltip>
										<div class="w-100" v-if="showBudgetPreview">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														dark
														small
														block
														outlined
														@click="contractToPdf"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-file-pdf-box</v-icon>
														<p class="mb-0 ml-2 caption">Generar PDF y Enviar Presupuesto</p>
													</v-btn>
												</template>
												<span>Con esto podrás regenerar el PDF del presupuesto con nueva información</span>
											</v-tooltip>
										</div>
									</div>
									<div class="d-flex flex-column align-end justify-end flex-grow-1" v-else-if="disableContentBudget">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="green"
													dark
													class="mb-1"
													small
													block
													@click="disableContentBudget = false"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon small>mdi-file-pdf-box</v-icon>
													<p class="mb-0 ml-2 caption">Volver a Editar Presupuesto</p>
												</v-btn>
											</template>
											<span>Con esto podrás modificar el presupuesto. Si generas el PDF luego de modificarlo, el presupuesto volverá al estado "Creado"</span>
										</v-tooltip>
									</div>
									<div v-else>
										<v-chip
											class="wrap-chip text-center"
											color="#FF120B"
											label
											outlined
											x-small
										>
											<b>Para continuar por favor asigna un responsable</b>
										</v-chip>
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<v-card :loading="loadingBudget" :disabled="loadingBudget" class="budget-modal-card mb-2"
				ref="budgetSecondHeaderInfo"
				:style="isScrolled ? {
					position: 'sticky',
					top: budgetHeaderHeight+'px',
					left: '0',
					right: '0',
					zIndex: 9
				} : {}">
				<v-card-text class="py-4">
					<div class="d-flex align-start caption" v-if="budget">
						<div class="d-flex align-center justify-space-between flex-1" style="gap: 5px;">
							<div>
								<v-select
									v-model="selectedUfValue"
									:items="ufValues"
									:menu-props="{ top: true, offsetY: true }"
									label="Seleccione Valor UF"
									item-text="uf_value"
									item-value="id"
									class="custom-height-search custom-height-calendar custom-select-uf align-center mb-0 mr-1 w-100"
									outlined
									dense
									required
									return-object
									:disabled="disableContentBudget"
									@change="changeUfValue"
								>
									<template v-slot:item="data">
										<v-list-item-content>
											<v-list-item-title>
												<div class="d-flex align-center justify-space-between" style="width: 180px">
													<p class="mb-0">{{data.item.date | toDateFormat}}</p>
													<p class="mb-0 font-weight-bold">${{data.item.uf_value | toThousandFilter(2)}}</p>
												</div>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="data">
										<div class="d-flex align-center justify-space-between" style="width: 180px;margin-bottom: 10px;">
											<p class="mb-0 caption">{{data.item.date | toDateFormat}}</p>
											<span>-</span>
											<p class="mb-0 font-weight-bold caption">${{data.item.uf_value | toThousandFilter(2)}}</p>
										</div>
									</template>
								</v-select>
							</div>
							<div>
								<v-select
									:value="budget.tax_id"
									:items="taxOptions"
									:loading="$store.state.general.loadingTaxesOptions"
									:menu-props="{ top: true, offsetY: true }"
									item-text="name"
									item-value="id"
									label="Tipo Impuesto"
									class="custom-height-search custom-height-calendar flex-grow-0"
									outlined
									dense
									required
									return-object
									@change="changeTaxSelection"
								>
									<template v-slot:item="data">
										<v-list-item-content>
											<v-list-item-title>
												<div class="d-flex align-center justify-space-between">
													<div class="d-flex align-center justify-space-between flex-1">
														<p class="mb-0 flex-1">{{data.item.tax.name}}</p>
														<p class="mb-0 font-weight-bold">{{data.item.tax.value}}%</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="data">
										<div class="d-flex align-center justify-space-between flex-1" style="min-width: 100%;">
											<p class="mb-0 caption flex-1">{{data.item.tax.name}}</p>
											<p class="mb-0 font-weight-bold caption">{{data.item.tax.value}}%</p>
										</div>
									</template>
								</v-select>
							</div>
							<CompanyTemplatesHandler
								:type="'budget'"
								:itemContent="budget"
								:disabled="disableContentBudget"
								@template-content-selected="templateContentSelected"/>

							<ProjectLineDocumentsMenu :project_line_id="project?.project_line_info?.project_line_id" :size="'small'"/>
						</div>
						<div v-if="budget.last_status?.status == budgetStatuses.OBSERVADO_CONTRAPARTE">
							<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
								<div class="custom-warning-observation px-2 py-1">
									<p class="mb-0 caption font-weight-bold warning--text">Observaciones Cliente</p>
									<p class="mb-0 caption warning--text">Revisa la siguiente observación y envía un nuevo presupuesto para revisión</p>
								</div>
							</div>
							<v-divider class="mx-2" vertical></v-divider>
							<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
								<p class="mb-0 caption font-weight-bold">Última Observación</p>
								<p class="mb-0">{{ budget.last_observation?.observation }}</p>
							</div>
							<v-divider class="mx-2" vertical></v-divider>
							<div class="d-flex flex-column justify-end align-end" style="width: 270px;min-width: 270px;">
								<v-menu offset-y>
									<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
										<v-tooltip bottom>
											<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
												<v-btn
													depressed
													color="#959595"
													dark
													small
													outlined
													v-bind="{ ...tooltipAttrs, ...menuAttrs }"
													v-on="{ ...tooltipOn, ...menuOn }"
												>
													<v-icon class="mr-2" small>mdi-briefcase-clock-outline</v-icon>
													<p class="caption mb-0">Historial de Observaciones</p>
												</v-btn>
											</template>
											<span>Historial de observaciones</span>
										</v-tooltip>
									</template>
									<v-list dense class="py-0 white">
										<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
											<div>
												<p class="caption mb-0 font-weight-bold white--text">Historial de Observaciones</p>
											</div>
										</v-list-item>
										<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
											<div class="d-flex justify-space-between align-center flex-grow-1">
												<p class="caption mb-0 text--disabled">Observación</p>
												<p class="caption mb-0 text--disabled" style="width: 90px;">Fecha</p>
											</div>
										</v-list-item>
										<v-divider></v-divider>
										<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
											<v-list-item
												v-for="(observation, index) in budget.observations"
												:key="'ctstatus-'+index"
												dense
												style="min-width: 350px;max-width: 450px;"
												class="white"
											>
												<v-list-item-title dense>
													<div class="d-flex justify-space-between align-center item-background-hover">
														<div class="d-flex flex-1 align-center justify-space-between caption mr-6" style="flex-wrap: wrap; min-width: 0;">
															<p class="mb-0 text-wrap">{{ observation.observation }}</p>
														</div>
														<div class="d-flex justify-end caption" style="width: 90px;">
															<p class="mb-0 caption text-end">{{ observation.created_at | toDateTime }}</p>
														</div>
													</div>
												</v-list-item-title>
											</v-list-item>
										</v-list-item-group>
									</v-list>
								</v-menu>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<v-card :loading="loadingBudget" :disabled="disableContent" class="budget-modal-card" v-if="!showBudgetPreview">
				<v-card-text class="py-4">
					<div>
						<div>
							<div class="d-flex justify-center align-center">
								<div class="pa-2 w-100">
									<v-menu
										ref="menu"
										v-model="menuTitle"
										transition="scale-transition"
										offset-y
										left
										nudge-top="-10"
										eager
									>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="#524D4D"
												outlined
												dark
												small
												block
												v-bind="attrs"
												v-on="on"
											>
												<div class="d-flex align-center justify-space-between py-2 w-100">
													<p class="mb-0 mr-2">{{budget.title ? budget.title:'Seleccione Título para el Presupuesto'}}</p>
													<v-icon>mdi-chevron-down</v-icon>
												</div>
											</v-btn>
										</template>
										<div class="white d-flex flex-column">
											<div>
												<v-list class="template-list white" max-height="300px" dense>
													<v-list-item
														class="template-list-item white"
														v-for="(title, i) in $store.state.budget.companiesBudgetTitles" :key="'bt-' + i"
														@click="onChangeTitle(title.title)">
														<v-list-item-content>
															<v-list-item-title>{{title.title}}</v-list-item-title>
														</v-list-item-content>
														<!-- <v-list-item-action>
															<div class="d-flex align-center">
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			fab
																			dark
																			x-small
																			icon
																			color="error"
																			@click="deleteTitle(title.id)"
																			v-bind="attrs"
																			v-on="on"
																		>
																			<v-icon small dark>mdi-delete-outline</v-icon>
																		</v-btn>
																	</template>
																	<span>Eliminar</span>
																</v-tooltip>
															</div>
														</v-list-item-action> -->
													</v-list-item>
												</v-list>
											</div>
										</div>
									</v-menu>
								</div>
								<div
									v-if="menuOpen"
									style="position: fixed;height: 100vh;width:100vw;top:0;left:0;z-index: 8;background-color: rgba(0,0,0,0.2);"
									@click="menuOpen = false"
									></div>
								<v-menu
									v-model="menuOpen"
									bottom
									offset-y
									right
									min-width="500"
									max-width="500"
									content-class="container-notification-menu-header"
									:close-on-content-click="false"
									:close-on-click="false"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											small
											color="#959595"
											class="mr-2"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon dark>mdi-cog-outline</v-icon>
										</v-btn>
									</template>
									<div class="white" style="position: relative;">
										<div dense class="d-flex align-center justify-space-between px-2 py-1" style="background: #959595;">
											<p class="caption mb-0 font-weight-bold white--text">Configuración Títulos</p>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon color="white" class="mr-3"
																v-bind="attrs"
																v-on="on"
																small
																@click="setBudgetTitle(null)">
														<v-icon>mdi-plus</v-icon>
													</v-btn>
												</template>
												<span>Nuevo título para Presupuestos</span>
											</v-tooltip>
										</div>
										<div class="px-2 py-1">
											<v-list class="pt-0" style="max-height: 300px;overflow: scroll;">
												<v-list-item
													v-for="(item, i) in $store.state.budget.companiesBudgetTitles"
													:key="i"
													class="px-0 py-0"
												>
													<div style="width: 100%">
														<div class="d-flex flex-row px-2 pt-2 justify-space-between">
															<div class="pr-4 caption">
																<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.title }}</p>
															</div>
															<div>
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			icon
																			dark
																			x-small
																			color="warning"
																			@click="setBudgetTitle(item)"
																			v-bind="attrs"
																			v-on="on"
																		>
																			<v-icon small dark>mdi-pencil</v-icon>
																		</v-btn>
																	</template>
																	<span>Editar Título</span>
																</v-tooltip>
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			icon
																			dark
																			x-small
																			color="error"
																			@click="deleteBugdetTitle(item)"
																			v-bind="attrs"
																			v-on="on"
																		>
																			<v-icon small dark>mdi-delete-outline</v-icon>
																		</v-btn>
																	</template>
																	<span>Eliminar Título</span>
																</v-tooltip>
															</div>
														</div>
													</div>
												</v-list-item>
											</v-list>
										</div>
									</div>
								</v-menu>
							</div>
							<v-simple-table>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left" style="width: 35%;">
												Concepto
											</th>
											<th class="text-left" style="width: 30%;">
												Detalle
											</th>
											<th class="text-right" style="width: 10%;min-width: 100px;">
												UF
											</th>
											<th class="text-right" style="width: 15%;min-width: 170px;">
												Pesos
											</th>
											<th class="text-center" style="width: 5%;min-width: 85px;">
												Acciones
											</th>
										</tr>
									</thead>
									<tbody
											v-for="( budget_category, index ) in budget?.categories"
											:key="'cat' + index">
										<tr>
											<td colspan="5">
												<div class="d-flex align-center" v-if="budget_category.edit">
													<v-text-field
														v-model="budget_category.number"
														label="Etapa"
														outlined
														required
														dense
														hide-details
														:loading="loadingBudget"
														class="custom-height-search custom-height-calendar mr-2"
														style="max-width: 90px"
														type="number"
														@keypress="isNumberKey"
														:rules="requiredRule"
													></v-text-field>
													<v-select
														v-model="budget_category.name"
														:items="$store.state.budget.companiesBudgetCategories"
														:loading="$store.state.budget.loadingBudgetCategories"
														:menu-props="{ top: true, offsetY: true }"
														item-text="name"
														item-value="name"
														label="Descripción"
														class="custom-height-search custom-height-calendar"
														outlined
														dense
														required
													>
													</v-select>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																icon
																dark
																x-small
																color="success"
																class="mx-4"
																@click="sendEditBugdetPartCategory(budget_category, index)"
																v-bind="attrs"
																v-on="on"
															>
																<v-icon small dark>mdi-check-outline</v-icon>
															</v-btn>
														</template>
														<span>Editar categoría</span>
													</v-tooltip>
												</div>
												<div class="d-flex align-center justify-space-between py-2 font-weight-bold text--secondary" v-else>
													{{budget_category.number}}º Etapa - {{budget_category.name}}
													<div class="d-flex align-center">
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn
																	icon
																	dark
																	x-small
																	color="warning"
																	class="mx-2"
																	@click="editBudgetCategory(index, true)"
																	v-bind="attrs"
																	v-on="on"
																>
																	<v-icon small dark>mdi-pencil</v-icon>
																</v-btn>
															</template>
															<span>Editar categoría</span>
														</v-tooltip>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn
																	icon
																	dark
																	x-small
																	color="error"
																	@click="removeCategory(budget_category.id)"
																	v-bind="attrs"
																	v-on="on"
																>
																	<v-icon small dark>mdi-delete-outline</v-icon>
																</v-btn>
															</template>
															<span>Eliminar categoría</span>
														</v-tooltip>
													</div>
												</div>
											</td>
										</tr>
										<tr
											v-for="( budget_part, index_b ) in budget_category.parts"
											:key="'part' + index_b">
											<td class="text-left">
												<v-form ref="formconcept_filled" style="width: 100%;">
													<v-select
														v-model="budget_part.concept"
														:items="$store.state.budget.companiesBudgetConcepts"
														:loading="$store.state.budget.loadingBudgetConcepts || loadingBudget"
														:menu-props="{ top: true, offsetY: true }"
														item-text="name"
														item-value="name"
														label="Concepto"
														class="custom-height-search custom-height-calendar"
														outlined
														dense
														hide-details
														style="font-size: 14px;max-width: 360px;"
														@change="() => autoConfirm(true)"
														required
														:rules="requiredRule"
													>
													</v-select>
												</v-form>
											</td>
											<td class="text-left">
												<v-form ref="formdetail_filled" style="width: 100%;">
													<v-select
														v-model="budget_part.detail"
														:items="$store.state.budget.companiesBudgetDetails"
														:loading="$store.state.budget.loadingBudgetDetails || loadingBudget"
														:menu-props="{ top: true, offsetY: true }"
														item-text="name"
														item-value="name"
														label="Detalle"
														class="custom-height-search custom-height-calendar"
														outlined
														dense
														style="font-size: 14px;max-width: 300px;"
														@change="() => autoConfirm(true)"
														required
													>
													</v-select>
												</v-form>
											</td>
											<td class="text-right">
												<div class="d-flex align-center justify-end" style="width: 100%;">
													<v-form ref="formvalue" style="width: 100%;">
														<v-text-field
															v-model="budget_part.value"
															label="Monto (UF)"
															outlined
															required
															dense
															hide-details
															:loading="loadingBudget"
															class="custom-height-search custom-height-calendar"
															style="font-size: 14px;"
															@keypress="isNumberKey"
															@blur="() => autoConfirm()"
															:rules="requiredRule"
														></v-text-field>
													</v-form>
												</div>
											</td>
											<td class="text-right">
												<p class="mb-0">${{Math.round(budget_part.value * ufValue) | toThousandFilter}}</p>
												<p class="mb-0 text--disabled" style="font-size: 10px;" v-if="budget.tax_value.value > 0"><b>+ {{ budget.tax_value.name }} ({{ budget.tax_value.value }}%)</b></p>
											</td>
											<td class="text-center">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															dark
															x-small
															color="error"
															@click="deleteBugdetPart(budget_part, index, index_b)"
															v-bind="attrs"
															v-on="on"
														>
															<v-icon small dark>mdi-delete-outline</v-icon>
														</v-btn>
													</template>
													<span>Eliminar Item</span>
												</v-tooltip>
											</td>
										</tr>
										<tr>
											<td colspan="5">
												<div class="d-flex align-center">
													<v-btn
														depressed
														color="#959595"
														class="my-2 flex-grow-1 mx-1"
														small
														outlined
														@click="addNewItem(budget_category.id, index)"
													>
														<v-icon>mdi-plus</v-icon>
														<p class="mb-0 ml-2 caption">Agregar Item a Etapa</p>
													</v-btn>
												</div>
											</td>
										</tr>
									</tbody>
									<tbody>
										<tr>
											<td colspan="5">
												<v-divider class="my-2"></v-divider>
												<v-btn
													depressed
													color="#959595"
													class="my-2 flex-grow-0 mx-1"
													small
													outlined
													block
													@click="addNewItem()"
												>
													<v-icon>mdi-plus</v-icon>
													<p class="mb-0 ml-2 caption">Agregar Etapa</p>
												</v-btn>
											</td>
										</tr>
										<tr v-if="budget">
											<td class="text-left font-weight-bold">
												Presupuesto Total
											</td>
											<td class="text-right">
												<div>
													<p class="mb-0 caption font-weight-bold" v-if="budget.tax_value.value > 0">Neto:</p>
													<p class="mb-0 caption font-weight-bold" v-if="budget.tax_value.value > 0">{{ budget.tax_value.name }} {{ budget.tax_value.value }}%:</p>
													<p class="mb-0 font-weight-bold">Total:</p>
												</div>
											</td>
											<td class="text-right">
												<div>
													<p class="mb-0 caption font-weight-bold" v-if="budget.tax_value.value > 0">{{budget_total | toThousandFilter(2)}} UF</p>
													<p class="mb-0 caption font-weight-bold" v-if="budget.tax_value.value > 0">{{budget_total_tax | toThousandFilter(2)}} UF</p>
													<p class="mb-0 font-weight-bold">{{budget_total_taxed | toThousandFilter(2)}} UF</p>
												</div>
											</td>
											<td class="text-right">
												<div>
													<p class="mb-0 caption font-weight-bold" v-if="budget.tax_value.value > 0">${{budget_total * ufValue | toThousandFilter}}</p>
													<p class="mb-0 caption font-weight-bold" v-if="budget.tax_value.value > 0">${{budget_total_tax * ufValue | toThousandFilter}}</p>
													<p class="mb-0 font-weight-bold">${{budget_total_taxed * ufValue | toThousandFilter}}</p>
												</div>
											</td>
											<td>
											</td>
										</tr>
										<tr v-else>
											<td colspan="5" class="text-center">
												<div class="pt-2">
													<p class="mb-1">Aún no hay items para este presupuesto, agrega uno para comenzar</p>
													<v-btn
														depressed
														color="#524D4D"
														small
														outlined
														@click="addNewItem()"
													>
														<v-icon>mdi-plus</v-icon>
														<p class="mb-0 ml-2 caption">Agregar Item</p>
													</v-btn>
												</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
							<v-divider class="my-2"></v-divider>
							<div>
								<div class="d-flex align-center justify-space-between my-2">
									<div class="d-flex align-center">
										<p class="font-weight-bold body-2 mb-0 mr-2">Notas del Presupuesto</p>
									</div>
									<div>
										<v-menu
											v-model="menuNotesOpen"
											top
											offset-x
											left
											min-width="500"
											max-width="500"
											content-class="container-notification-menu-header"
											:close-on-click="false"
											:close-on-content-click="false"
											@input="changeMenu"
										>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													icon
													dark
													small
													color="#959595"
													class="mr-2"
													v-bind="attrs"
													v-on="on"
												>
													<v-icon dark>mdi-plus</v-icon>
												</v-btn>
											</template>
											<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
												<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
													<div class="d-flex justify-space-between w-100">
														<p class="caption mb-0 font-weight-bold white--text">Agregar Nota a Presupuesto</p>
														<v-btn
															icon
															dark
															x-small
															color="white"
															@click="changeMenu(false)"
														>
															<v-icon dark>mdi-close</v-icon>
														</v-btn>
													</div>
												</v-list-item>
												<v-list-item-group color="#524D4D">
													<v-list-item
														dense
														@click="addNote(null)"
													>
														<v-list-item-title dense>
															Nueva (Vacía)
														</v-list-item-title>
													</v-list-item>
													<v-list-item
														v-for="(note, index) in $store.state.budget.companiesBudgetNotes"
														:key="index"
														dense
														@click="addNote(note)"
													>
														<v-list-item-title dense>
															{{ note.name }}
														</v-list-item-title>
													</v-list-item>
												</v-list-item-group>
											</v-list>
										</v-menu>
									</div>
								</div>
								<div v-if="editNewNote" class="py-4">
									<div class="pa-2">
										<vue2-tinymce-editor
											v-model="newNote.note"
											:height="150"
											:options="{ menubar: false }"
											ref="tinymceEditor">
										</vue2-tinymce-editor>
									</div>
									<div class="d-flex justify-end">
										<v-btn
											depressed
											color="#959595"
											small
											dark
											outlined
											class="mr-2"
											@click="cancelEditNote"
										>
											<v-icon small>mdi-close</v-icon>
											<p class="mb-0 ml-2 caption">Cancelar Nota</p>
										</v-btn>
										<v-btn
											depressed
											color="#FF120B"
											small
											dark
											@click="acceptEditNote"
										>
											<v-icon small>mdi-check</v-icon>
											<p class="mb-0 ml-2 caption">Guardar Nota</p>
										</v-btn>
									</div>
									<v-divider class="my-2"></v-divider>
								</div>
								<v-list v-else dense class="py-0 mb-2" max-height="300" style="z-index: 9999;background-color: white;">
									<draggable
										v-if="budget"
										v-model="budget.notes"
										handle=".handle_drag"
										@end="startEndDragNotesEvent">
										<v-list-item
											v-for="(note, index) in budget?.notes"
											:key="index"
											dense
										>
											<v-list-item-title dense>
												<div style="width: 100%">
													<div class="d-flex flex-row px-0 pt-2 justify-space-between">
														<div class="d-flex flex-row align-center caption">
															<v-icon class="handle_drag mr-2">mdi-unfold-more-horizontal</v-icon>
															<div class="budget-note-container" v-html="note.note"></div>
														</div>
														<div>
															<v-tooltip bottom>
																<template v-slot:activator="{ on, attrs }">
																	<v-btn
																		icon
																		dark
																		x-small
																		color="warning"
																		v-bind="attrs"
																		v-on="on"
																		@click="editNote(note)"
																	>
																		<v-icon small dark>mdi-pencil</v-icon>
																	</v-btn>
																</template>
																<span>Editar Nota</span>
															</v-tooltip>
															<v-tooltip bottom>
																<template v-slot:activator="{ on, attrs }">
																	<v-btn
																		icon
																		dark
																		x-small
																		color="error"
																		@click="removeBudgetNote(note.id)"
																		v-bind="attrs"
																		v-on="on"
																	>
																		<v-icon small dark>mdi-delete-outline</v-icon>
																	</v-btn>
																</template>
																<span>Eliminar Nota</span>
															</v-tooltip>
														</div>
													</div>
													<v-divider class="mt-2 mx-2"></v-divider>
												</div>
											</v-list-item-title>
										</v-list-item>
									</draggable>
								</v-list>
							</div>
							<div class="d-flex justify-end">
								<v-btn
									depressed
									color="#FF120B"
									small
									dark
									@click="confirmBudget(true, true)"
								>
									<v-icon small>mdi-check</v-icon>
									<p class="mb-0 ml-2 caption">Guardar</p>
								</v-btn>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<BudgetTextEditor v-if="budget && showBudgetPreview" :budget="budget"/>
		</div>
	</v-container>
</template>

<script>
import draggable from 'vuedraggable'
import { Vue2TinymceEditor } from "vue2-tinymce-editor"
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import budgetStatuses from '@/components/Helpers/Constants/budget.js'
import {updateBudget, deleteBudgetTitle, setBudgetsPartCategory, removeBudgetPartCategory, setItemBudgetPart, addPreProjectBudgetsPart, removeItemBudgetPart, createBudgetNote, updateBudgetNote, deleteBudgetNote, updateOrderBudgetNote, getBudgetById, sendBudgetPdfEmail, createBudgetPdfFromPreview, setBudgetInfo, createBudget} from '@/helpers/api/budgets'
import { createContract } from '@/helpers/api/contracts'

import {setResponsible as setResponsiblePreProject} from '@/helpers/api/preprojects'
import {setResponsible as setResponsibleProject} from '@/helpers/api/projects'
import {editCrmResponsible} from '@/helpers/api/crm'

import CompanyTemplatesHandler from '@/components/Helpers/Components/CompanyTemplatesHandler'
import BudgetSettings from '@/components/Modals/Budgets/BudgetSettings'
import BudgetStatusHistory from '@/components/Modals/Budgets/BudgetStatusHistory'
import BudgetPdfHistory from '@/components/Helpers/Components/BudgetPdfHistory'
import BudgetTextEditor from '@/components/Helpers/Editor/BudgetTextEditor.vue'
import ProjectLineDocumentsMenu from '@/components/Views/Projects/Parts/ProjectLineDocumentsMenu'

export default {
	name: 'BudgetDetail',
	components: {CompanyTemplatesHandler, BudgetSettings, BudgetStatusHistory, BudgetPdfHistory, BudgetTextEditor, ProjectLineDocumentsMenu, draggable, Vue2TinymceEditor},
	computed: {
		project(){
			return this.budget?.morphable
		},
		taxOptions(){
			return this.$store.state.general.taxesOptions
		},
		disableContent(){
			return this.loadingBudget || this.disableContentBudget
		},
		canEditInfo(){
			// Puede editar sólo si tiene permiso y si no hay un contrato firmado en la línea de proyectos
			return !this.budget?.morphable?.pl_signed_contract
		},
		startPreviewButtonText(){
			if(this.showBudgetPreview){
				return 'Volver a Edición de Presupuesto'
			}
			return 'Previsualizar y Enviar Presupuesto'
		},
		startPreviewButtonTextTooltip(){
			if(this.budget?.pdf && (this.budget.last_status?.status == budgetStatuses.ACEPTADO || this.budget.last_status?.status == budgetStatuses.RECHAZADO)){
				return 'Esto hará que el estado del presupuesto vuelva a Creado'
			}
			if(this.showBudgetPreview){
				return 'Vuelve a la edición del Presupuesto'
			}
			return 'Previsualiza y envía el presupuesto al cliente para su revisión'
		},
		openBudgetModal(){
			return this.$store.state.general.newBudgetModal
		},
		userResponsible(){
			if(this.budget.morphable?.responsible?.profile){
				let fullName = this.budget.morphable?.responsible?.profile?.name
				if(this.budget.morphable?.responsible?.profile?.lastname){
					fullName = fullName + ' ' + this.budget.morphable?.responsible?.profile?.lastname + ' ' + this.budget.morphable?.responsible?.profile?.second_lastname
				}
				return fullName
			}
			return null
		},
		budget_total(){
			if(!this.budget.categories) return 0
			return this.budget.categories
				.map(category => category.parts)
				.flat()
				.map(part => part.value)
				.reduce((acc, value) => acc + parseInt(value), 0)
		},
		budget_total_tax(){
			let total = this.budget_total
			if(this.budget.tax_value && this.budget.tax_value.value > 0){
				if(this.budget.tax_value.type == 1){
					total = total * (this.budget.tax_value.value / 100)
				}
				else{
					const tax_total = total / (1 - (this.budget.tax_value.value / 100))
					total = tax_total - total
				}
			}
			return total
		},
		budget_total_taxed(){
			let total = this.budget_total
			if(this.budget.tax_value && this.budget.tax_value.value > 0){
				if(this.budget.tax_value.type == 1){
					total = total * (1 + (this.budget.tax_value.value / 100))
				}
				else{
					total = total / (1 - (this.budget.tax_value.value / 100))
				}
			}
			return total
		},
		item(){
			return this.$store.state.general.newBudgetModal.item
		},
		dayUfValue(){
			const valueUf = this.ufValues
			let todayData = null
			if(valueUf && valueUf.length > 0){
				const today = new Date().toISOString().split('T')[0];
				todayData = valueUf.find(item => item.date === today);
			}
			return todayData
		},
		ufValue(){
			return this.selectedUfValue?.uf_value || this.dayUfValue?.uf_value
		},
		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		queryRoute(){
			return this.$route.query
		},
		isScrolled(){
			return this.$store.state.budget.scrolledBudget > 0
		},
		budgetHeaderHeight(){
			return this.$store.state.budget.budgetHeaderHeight
		},
		budgetSecondHeaderHeight(){
			return this.$store.state.budget.budgetSecondHeaderHeight
		},
	},
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('users/getUserFromCompany')
				this.$store.dispatch('budget/getBudgetTitles')
			}
		},
		openBudgetModal(value){
			if(value){
				localStorage.setItem('budget_open', JSON.stringify(value))
			}
			else{
				localStorage.removeItem('budget_open')
			}
		},
		budget(newValue){
			if(newValue){
				localStorage.setItem('last_working_budget', JSON.stringify(this.budget))
				if(this.budget?.morphable?.pl_signed_contract){
					const data = {
						message: 'Este Presupuesto está en una línea de proyecto con un contrato firmado, por lo tanto la información del proyecto no puede ser editada.',
						title: 'Línea de Proyecto con Contrato',
						created: new Date(),
						type: 'warning',
						icon: 'mdi-exclamation',
						color: 'orange'
					}
					this.$store.dispatch('general/addMessage', data)
				}
				
				if(this.budget?.last_status?.status == budgetStatuses.ACEPTADO || this.budget?.last_status?.status == budgetStatuses.RECHAZADO){
					this.disableContentBudget = true
				}
				else{
					this.disableContentBudget = false
				}
			}
		},
		queryRoute(){
			const budget_id = this.$route.query.id
			if(this.budget && this.budget.id != budget_id){
				this.budget = null
				this.getBudgetInfo()
			}
		},
		loadingBudgetInfo(val){
      if (!val) {
        this.$nextTick(() => {
          this.initResizeObserver();
        });
      }
		},
		dayUfValue(newValue){
			if (newValue && !this.budget?.uf_value_id) {
				this.selectedUfValue = newValue;
			}
		},
	},
  data() {
    return {
			budgetStatuses,
			menuOpen: false,
			disableContentBudget: false,
			userCompanyMenu: false,
			menuTitle: false,
			prefixMenu: false,
			loadingBudgetInfo: true,
			responsibleMenu: false,
			isChanged: false,
			menuNotesOpen: false,
			menuConcepts: false,
			showBudgetPreview: false,
			showNewBudgetPart: true,
			loadingBudget: false,
			concept: null,
			budget_id: null,
			budget: null,
			editNewNote: false,
      resizeObserver: null,
			selectedUfValue: null,
			newNote: {
				id: null,
				note: null
			},
			newBudgetPart: {
				value: null,
				stage: null,
				concept: null,
				detail: null,
				item_type: null,
				item_id: null
			},
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			concepts: [
				{ "id": 1, "name": "Proyecto de Arquitectura" },
				{ "id": 2, "name": "Proyecto de Ingeniería y Memoria de Cálculo Estructural" },
				{ "id": 3, "name": "Proyectos de Agua Potable y Alcantarillado + Certificación Sanitaria" },
				{ "id": 4, "name": "Proyecto de Electricidad + Certificación SEC" },
				{ "id": 5, "name": "Proyecto de Corrientes Débiles" },
				{ "id": 6, "name": "Proyecto de Gas + Certificación SEC" },
				{ "id": 7, "name": "Proyecto de Climatización" },
				{ "id": 8, "name": "Recepción Definitiva" },
				{ "id": 9, "name": "Otros" }
			]
		}
	},
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
	mounted(){
		if(this.selectedCompany){
			this.$store.dispatch('users/getUserFromCompany')
			this.$store.dispatch('budget/getBudgetTitles')
		}
		this.getBudgetInfo()
		this.getUfValues()
		this.initResizeObserver()
		// if(this.$store.state.general.newBudgetModal){
		// 	localStorage.setItem('budget_open', JSON.stringify(this.$store.state.general.newBudgetModal))
		// }
		// this.budget = this.$store.state.general.newBudgetModal.budget
		// if(this.$store.state.general.newBudgetModal.budget_id && this.$store.state.general.newBudgetModal.force_get){
		// 	this.getBudgetInfo(this.$store.state.general.newBudgetModal.budget_id)
		// 	return
		// }
		// if(this.budgetId){

		// }
		// this.newBudgetPart = {
		// 	value: null,
		// 	budget_category_id: null,
		// 	concept: null,
		// 	detail: null,
		// 	item_type: this.budget.morphable_type,
		// 	item_id: this.budget.morphable_id
		// }
		// if(!this.budget.id){
		// 	this.createNewBudget()
		// }
		eventBus.$on('reloadInformation', this._onReloadBudget)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this._onReloadBudget);
		localStorage.removeItem('budget_open')
	},
	methods: {
		changeTaxSelection(tax){
			this.budget = {...this.budget, ...{tax_id: tax.tax.id, tax_value: tax.tax}}
		},
		templateContentSelected(content){
			this.budget = {...this.budget, ...content}
		},
		getUfValues(){
			this.$store.dispatch('general/getPosteriorDaysUf')
		},
		async changeUfValue(uf_value){
			const uf_value_id = uf_value.id
			this.budget = {...this.budget, ...{uf_value_id}}
			await updateBudget({
				budget_id: this.budget.id,
				uf_value_id
			})
			this.getBudgetInfo()
		},
    initResizeObserver() {
      const el = this.$refs.budgetHeaderInfo?.$el || this.$refs.budgetHeaderInfo;
      const el2 = this.$refs.budgetSecondHeaderInfo?.$el || this.$refs.budgetSecondHeaderInfo;
      if (!el) return;

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.resizeObserver = new ResizeObserver(() => {
				this.$store.commit('budget/setBudgetHeaderHeight', el.offsetHeight)
				this.$store.commit('budget/setBudgetSecondHeaderHeight', el2.offsetHeight)
      });

      this.resizeObserver.observe(el);
    },
		onScroll(event){
			this.$store.commit('budget/setScrolledBudget', event.target.scrollTop)
		},
		_onReloadBudget(data){
			if(this.budget && data.budget_id == this.budget.id){
				this.getBudgetInfo()
			}
		},
		async createNewBudget(){
			const budget = await createBudget({
				item_type: this.budget.morphable_type,
				item_id: this.budget.morphable_id
			})
			if(budget.code == 200){
				this.budget = budget.budget
			}
		},
		reverseContentViewToPlaceholders(content) {
			let result = content;
			result = result.replace(/<span id="(.*?)"[^>]*>(.*?)<\/span>/g, (match, placeholder) => {
					return `${placeholder}`;
			})
			return result;
		},
		async contractToPdf(){
			const contentEditorRef = this.$store.state.budget.budgetEditorRef
			// const data = {
			// 	budget_id: this.budget.id,
			// 	contents: JSON.stringify( contentEditorRef.pages.map(page => page.prev_innerHTML) )
			// }
			const data = {
				budget_id: this.budget.id,
				contents: JSON.stringify( contentEditorRef.pages.map(page => this.reverseContentViewToPlaceholders(page.prev_innerHTML) ) )
			}
			const pdf = await createBudgetPdfFromPreview(data)
			if(pdf.code == 200){
				const budget = {...this.budget, ...{pdf: pdf.budget_pdf}}
				this.$store.commit('budget/setBudgetPdfModal', budget)
				this.getBudgetInfo()
				this.getParentInfo()
			}
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
		async getBudgetInfo(){
			const budget = await getBudgetById({budget_id: this.$route.query.id})
			if(budget.code == 200){
				this.budget = budget.budget
				if(this.budget.uf_value){
					this.selectedUfValue = this.budget.uf_value
				}
			}
			this.loadingBudgetInfo = false
		},
		editNote(note){
			this.newNote = {
				id: note.id,
				note: note.note
			}
			this.editNewNote = true
		},
		cancelEditNote(){
			this.editNewNote = false
			this.newNote = {
				id: null,
				note: null
			}
		},
		async acceptEditNote(){
			if(this.newNote.id){
				const data = {
					budget_note_id: this.newNote.id,
					note: this.newNote.note
				}
				await updateBudgetNote(data)
			}
			else{
				this.addNote({note: this.newNote.note})
			}
			this.cancelEditNote()
		},
		changeMenu(value){
			this.menuNotesOpen = value
		},
		async addNote(note = null){
			if(note){
				await createBudgetNote({
					budget_id: this.budget.id,
					note: note.note
				})
				this.getBudgetInfo()
				this.getParentInfo()
			}
			else{
				this.newNote = {
					id: null,
					note: null
				}
				this.editNewNote = true
			}
			this.changeMenu(false)
		},
		startEndDragNotesEvent: _debounce(function(){ this.endDragNotesEvent() }, 200),
		async endDragNotesEvent(){
			const notes = this.budget.notes.map((note, index) => {
				return {id: note.id, order: index + 1}
			})
			await updateOrderBudgetNote({notes})
			this.getBudgetInfo()
			this.getParentInfo()
		},
		startShowBudgetPreview(){
			const forms = this.$refs.formconcept_filled

			const noForms = !forms || typeof forms.map !== 'function'
			const validations = noForms ? [] : forms.map(form => form?.validate?.() ?? false)
			const valid = validations.every(result => result)

			if (noForms || !valid) {
				this.setMessage({
					message: 'El presupuesto está incompleto o contiene campos sin llenar. Por favor, revisa los datos antes de continuar.',
					title: 'Validación',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				})
				return
			}
			this.showBudgetPreview = !this.showBudgetPreview
		},
		autoConfirm: _debounce(function(force = false) {
			if(force){
				this.isChanged = false
				this.confirmBudget(false)
			}
			else if( force || (!force && this.isChanged) ){
				this.isChanged = false
				this.confirmBudget(false)
			}
		}, 500),
		async confirmBudget(showLoader = true, final = false){
			const results = this.$refs.formconcept_filled.map(form => form.validate())
			const valid = results.every(result => result)
			if(!valid){
				const messageData = {
					message: 'Hay campos necesarios sin completar, por favor revisa el presupuesto.',
					title: 'Campos Requeridos',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				}
				this.setMessage(messageData)
				return
			}
			this.loadingBudget = showLoader
			const parts = this.budget.categories.map(cat => 
				cat.parts.map(part => ({
					...part, 
					value: parseInt(part.value, 10)
				}))
			).flat()
			const budget = await setItemBudgetPart({
				budget_id: this.budget.id,
				item_type: this.getType(this.budget.morphable_type),
				item_id: this.budget.morphable_id,
				parts
			})
			if(budget.code == 200){
				this.budget = budget.budget
			}
			this.getParentInfo()
			this.loadingBudget = false
			if(final){
				if(budget.code == 200){
					const messageData = {
						message: 'Presupuesto guardado correctamente',
						title: 'Presupuesto Guardado',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#3EBFA3',
					}
					this.setMessage(messageData)
				}
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		async removeCategory(category_id){
			this.loadingBudget = true
			const budget = await removeBudgetPartCategory({category_id})
			if(budget.code == 200){
				this.budget = budget.budget
			}
			this.getParentInfo()
			this.loadingBudget = false
		},
		async sendEditBugdetPartCategory(budget_category, index){
			this.loadingBudget = true
			const category = await setBudgetsPartCategory({
				...{
					budget_id: this.budget.id,
					item_type: this.getType(this.budget.morphable_type),
					item_id: this.budget.morphable_id,
				},
				...budget_category
			})
			if(category.code == 200){
				this.budget = category.budget
			}
			this.$set(this.budget.categories[index], 'edit', false);
			this.getParentInfo()
			this.loadingBudget = false
		},
		editBudgetCategory(index){
			this.$set(this.budget.categories[index], 'edit', true);
		},
		async addNewItem(category_id = null, index = null){
			if(!category_id){
				this.loadingBudget = true
				const index = this.budget?.categories ? this.budget.categories.length:0
				const category_number = this.budget && this.budget.categories ? index + 1:1
				let category_name = 'Nueva Etapa'
				
				const category = await setBudgetsPartCategory({
					budget_id: this.budget.id,
					item_type: this.getType(this.budget.morphable_type),
					item_id: this.budget.morphable_id,
					number: category_number,
					name: category_name
				})
				if(category.code == 200){
					this.budget = category.budget
				}
				this.getParentInfo()
				this.loadingBudget = false
				this.$set(this.budget.categories[index], 'edit', true);
			}
			else if(index || index === 0){
				this.$set(
					this.budget.categories[index],
					'parts',
					[
						...this.budget.categories[index].parts,
						...[{
							value: null,
							concept: null,
							detail: null,
							budget_category_id: category_id,
							item_type: this.getType(this.budget.morphable_type),
							item_id: this.budget.morphable_id
						}]
					]
				)
			}
		},
		handleConceptChange(value, index) {
			if (value.name === 'Otros') {
				this.$set(this.budget[index], 'concept', '');
			}
			this.autoConfirm()
		},
		isNumberKey(event) {
			const charCode = event.which ? event.which : event.keyCode;
			if (charCode < 48 || charCode > 57) {
				event.preventDefault();
			}
			else{
				this.isChanged = true
			}
		},
		async addNewPreProjectBudgetsPart(){
			this.newBudgetPart.value = parseInt(this.newBudgetPart.value)
			const data = {...this.newBudgetPart}
			this.loadingBudget = true
			this.newBudgetPart = {
				value: null,
				stage: null,
				concept: null,
				detail: null,
				item_type: this.getType(this.budget.morphable_type),
				item_id: this.budget.morphable_id,
			}
			this.$refs.formconcept.reset()
			this.$refs.formvalue.reset()
			const budget = await addPreProjectBudgetsPart(data)
			if(budget.code == 200){
				this.budget = budget.budget
			}
			this.loadingBudget = false
			this.getParentInfo()
		},
		async deleteBugdetPart(budget_part, index = null, index_b = null){
			if(budget_part.id){
				this.loadingBudget = true
				const budget = await removeItemBudgetPart({budget_part_id: budget_part.id})
				if(budget.code == 200){
					this.budget = budget.budget
				}
				this.loadingBudget = false
				this.getParentInfo()
			}
			else if (Number.isInteger(index) && Number.isInteger(index_b)) {
				this.budget.categories[index].parts.splice(index_b, 1);
			}
		},
		showNewBudgetPartStart(){
			this.newBudgetPart = {
				value: null,
				stage: null,
				concept: null,
				detail: null,
				item_type: this.getType(this.budget.morphable_type),
				item_id: this.budget.morphable_id
			}
			this.showNewBudgetPart = true
		},
		cleanNewBudgetPart(){
			this.newBudgetPart = {
				value: null,
				stage: null,
				concept: null,
				detail: null,
				item_type: this.getType(this.budget.morphable_type),
				item_id: this.budget.morphable_id
			}
		},
		gotToAssociation(item){
			const item_type = this.getType(item.morphable_type)
			if(item_type == 'crm'){
				// this.$router.push({ name: 'Conversation', params: { id: item.morphable_id } })
				this.$store.commit('crm/setCrmModalId', item.morphable_id)
			}
			else if(item_type == 'preproject'){
				// this.$router.push({ name: 'PreProject', params: { id: item.morphable_id } })
				this.$store.commit('preprojects/setPreProjectModalId', item.morphable_id)
			}
			else if(item_type == 'project'){
				const messageData = {
					message: 'Detalle de proyectos en futuro módulo Proyectos',
					title: 'Sección en construcción',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		getParentInfo(){
			if(this.$route.name == 'Budgets'){
				this.$store.dispatch('budget/getCompanyBudgets')
			}
			else if(this.$route.name == 'PreProject'){
				this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.budget.morphable_id, showLoader: false})
			}
			else if(this.$route.name == 'PreProjects'){
				this.$store.dispatch('preprojects/getPreProjects')
			}
			else if(this.$route.name == 'CRM'){
				this.$store.dispatch('crm/getConversations')
			}
			else if(this.$route.name == 'ArchivedCRM'){
				this.$store.dispatch('crm/getArchivedConversations')
			}
			else if(this.$route.name == 'Conversation'){
				this.$store.dispatch('crm/getConversation', {conversation_id: this.budget.morphable_id, showLoader: false})
			}
			else if(this.newBudgetPart.item_type == 'preproject'){
				this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.budget.morphable_id, showLoader: false})
			}
			else if(this.newBudgetPart.item_type == 'crm'){
				this.$store.dispatch('crm/getConversation', {conversation_id: this.budget.morphable_id, showLoader: false})
			}
		},
		async removeBudgetNote(budget_note_id){
			await deleteBudgetNote({budget_note_id})
			this.getBudgetInfo()
			this.getParentInfo()
		},
		async changeBudgetPrefix(budget_prefix_id){
			await setBudgetInfo({budget_id: this.budget.id, budget_prefix_id})
			this.getBudgetInfo()
			this.getParentInfo()
			this.prefixMenu = false
		},
		changeResponsible: _debounce(function(responsible_id) { this._changeResponsible(responsible_id) }, 800),
		async _changeResponsible(responsible_id){
			console.log('this.budget: ', this.budget)
			const item_type = this.getType(this.budget.morphable_type)
			if(item_type == 'crm'){
				// await assignScheduleToUser({schedule_id: this.budget.morphable.schedule.user_schedule.id, new_user_id: responsible_id})
				await editCrmResponsible({conversation_id: this.budget.morphable_id, responsible_id})
			}
			else if(item_type == 'preproject'){
				await setResponsiblePreProject({preproject_id: this.budget.morphable_id, responsible_id})
			}
			else if(item_type == 'project'){
				await setResponsibleProject({project_id: this.budget.morphable_id, responsible_id, from_state: 'budget', contract_id: this.budget.id}) //Contract_id temporal
			}
			this.getBudgetInfo()
			this.getParentInfo()
			this.responsibleMenu = false
		},
		async sendEmailBudget(){
			const budget_r = await sendBudgetPdfEmail({budget_id: this.budget.id})
			if(budget_r.code === 200){
				const messageData = {
					message: 'Se ha enviado correctamente el presupuesto por correo',
					title: 'Presupuesto enviado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		openNewProjectModal(preproject){
			const pre_project = {...preproject, ...{doc_type: 1}}
			this.$store.commit('projects/setProjectModalInfo', pre_project)
			this.$store.commit('projects/setProjectModal', true)
		},
    async createContract(){
      if(this.budget.morphable_id){
				if(this.getType(this.budget.morphable_type) == 'preproject' || this.getType(this.budget.morphable_type) == 'crm'){
					this.openNewProjectModal({
						...this.budget.morphable,
						morphable_type: this.getType(this.budget.morphable_type),
					})
					return null
				}
				const data = {
					item_type: this.getType(this.budget.morphable_type),
					item_id: this.budget.morphable_id
				}
        const contract = await createContract(data)
        if(contract.code === 200){
          const messageData = {
            message: 'Se ha creado correctamente el contrato',
            title: 'Contrato creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
					this.$router.push({ name: 'ContractDetail', query: { id: contract.contract.id } })
          this.setMessage(messageData)
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
      }
    },
		async onChangeTitle(title){
			this.budget = {...this.budget, ...{title}}
			await updateBudget({
				budget_id: this.budget.id,
				title
			})
			this.getBudgetInfo()
		},
		setBudgetTitle(title = null){
			this.$store.commit('budget/setNewBudgetTitleModalEditing', title ? {...title, ...{budget_title_id: title.id}}:null)
      this.$store.commit('budget/setNewBudgetTitleModal', true)
		},
		async deleteBugdetTitle(title){
			await deleteBudgetTitle({budget_title_id: title.id})
			this.$store.dispatch('budget/getBudgetTitles')
		},
	}
}
</script>

<style>
	.v-dialog.budget-modal-custom{
		max-width: 1200px;
		width: 90vw;
		height: 95vh;
		max-height: 95vh;
	}
	.budget-note-tiny-editor {
		max-height: 140px !important;
		overflow: auto !important;
	}
</style>

<style scoped>
	.action-container{
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-warning-observation{
		border: 1px solid #fb8c00;
		border-radius: 6px;
	}
	/deep/ .budget-note-container p{margin-bottom: 0;}
</style>